import { SvgIcon, SvgIconProps } from "@mui/material";

const RefreshIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 20 20" {...props}>
			<path
				d="M16.6654 9.16658C16.4616 7.7001 15.7813 6.3413 14.7292 5.2995C13.6772 4.25769 12.3118 3.59068 10.8434 3.40121C9.37502 3.21174 7.88505 3.51032 6.60303 4.25096C5.32101 4.99159 4.31807 6.1332 3.7487 7.49992M3.33203 4.16658V7.49992H6.66536M3.33203 10.8333C3.53583 12.2997 4.21614 13.6585 5.26817 14.7003C6.32019 15.7421 7.68557 16.4092 9.15397 16.5986C10.6224 16.7881 12.1123 16.4895 13.3944 15.7489C14.6764 15.0082 15.6793 13.8666 16.2487 12.4999M16.6654 15.8333V12.4999H13.332"
				stroke="#FAFAFA"
				strokeOpacity="0.85"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
};

export default RefreshIcon;
